/*
 * fn: trackEvent
 *
 *  Tracks a GA event
 *
 */
import ReactGA from 'react-ga4'

import { type AnalyticsEventType, IS_ANALYTICS_ENABLED } from '@/defs/analytics'

export const trackEvent = ({ action, ...props }: AnalyticsEventType) => {
  if (!IS_ANALYTICS_ENABLED) return
  ReactGA.event(action, props)
}
